import React, { useState, useRef, useEffect, useMemo } from "react";
import { FaEye, FaTrash } from "react-icons/fa";
import { FaAngleLeft, FaAngleRight, FaPencil } from "react-icons/fa6";
import axios from "axios";
import { toast } from "react-toastify";
import BaseUrl from "../../base-api";
import { useNavigate } from "react-router-dom";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import Loader from "../Loader/Loader";
import AxiosInstance from "../../AxiosInstance";
import { handleAxiosError } from "../Utility/handleAxiosError";

const Result = () => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);

  const [newNotification, setNewNotification] = useState({
    title: "",
    file: null,
    advertisementNo: "",
    submissionDate: "",
  });


  const fileInputRef = useRef(null);
  const [currentNotification, setCurrentNotification] = useState(null);
  const [editTitle, setEditTitle] = useState("");
  const [currentEditId, setCurrentEditId] = useState("");
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editAdvertisementNo, setEditAdvertisementNo] = useState("");


  const filteredNotifications = useMemo(() => {
    if (!searchQuery) {
      return notifications;
    }
    const query = searchQuery.toLowerCase();
    return notifications.filter(
      (item) =>
        item.title.toLowerCase().includes(query) ||
        item.advertisementNo.toLowerCase().includes(query) ||
        (item.submissionDate && item.submissionDate.toLowerCase().includes(query))
    );
  }, [notifications, searchQuery]);


  const displayedNotifications = filteredNotifications;


  const fetchLinks = async (pageNumber = currentPage) => {

    const backendPage = pageNumber - 1;
    const token = sessionStorage.getItem("userToken");
    if (!token) {
      navigate("/login");
      return;
    }
    setLoading(true);
    try {

      const res = await AxiosInstance.get(
        `${BaseUrl}/api/advt/getAll`, {
        params: {
          page: backendPage,
          size: itemsPerPage,
        },
        // headers: {
        //   Authorization: token,
        //   'Content-Type': 'application/json',
        // },
      });

      if (res.data.status === 200) {
        setNotifications(
          res.data.data.content.map((item) => ({
            id: item.key,
            title: item.title,
            file: item.fileUrl && item.fileUrl.length > 0 ? item.fileUrl[0] : "",
            advertisementNo: item.advtNo,
            submissionDate: item.publishedDate,
          }))
        );

        setTotalPages(res.data.data.totalPages);
        setTotalItems(res.data.data.totalItems);
        setCurrentPage(pageNumber);
      } else {
        toast.error("Failed to fetch links.");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLinks(1);
  }, []);


  const handlePageChange = (pageNumber) => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      fetchLinks(pageNumber);
    }
  };

  const handleNextPage = () => {
    handlePageChange(currentPage + 1);
  };

  const handlePreviousPage = () => {
    handlePageChange(currentPage - 1);
  };

  // View Notification
const handleView = async (id) => {
  const notification = notifications.find((item) => item.id === id);
  const token = sessionStorage.getItem("userToken");

  try {
    const response = await fetch(`${BaseUrl}/api/advt/document/${id}`, {
      method: "GET",
      headers: {
        Authorization: token,
      },
    });

    if (!response.ok) {
      if (response.status === 404) {
        toast.error("Document not found.");
      } else {
        toast.error("Failed to load the document.");
      }
      return; // Exit early, do not open modal
    }

    const blob = await response.blob();
    const fileUrl = URL.createObjectURL(blob);

    setCurrentNotification({
      ...notification,
      file: fileUrl,
    });

    setIsViewModalOpen(true);
  } catch (error) {
    console.error("Error loading file:", error);
    toast.error("An unexpected error occurred while opening the document.");
  }
};




  // Edit Notification
  const handleEdit = (id) => {
    const notification = notifications.find((item) => item.id === id);
    setCurrentNotification(notification);
    setEditTitle(notification.title);
    setEditAdvertisementNo(notification.advertisementNo);
    setCurrentEditId(id);
    setIsEditModalOpen(true);
  };

  // Delete Notification
  const handleDelete = async (id) => {
    const toastId = toast.warn(
      <div
        style={{ textAlign: "center", fontSize: "18px", fontWeight: "bold" }}
      >
        <p>Are you sure you want to delete this notification?</p>
        <div className="d-flex justify-content-center">
          <button
            className="btn btn-danger btn-sm mx-2"
            onClick={() => confirmDelete(id, toastId)}
          >
            Yes
          </button>
          <button
            className="btn btn-secondary btn-sm"
            onClick={() => toast.dismiss(toastId)}
          >
            No
          </button>
        </div>
      </div>,
      {
        autoClose: false,
        closeOnClick: false,
        toastClassName: "toast-container",
        closeButton: false,
      }
    );
  };

  const confirmDelete = async (id, toastId) => {
    toast.dismiss(toastId);
    const loadingToast = toast.loading("Deleting notification...");
    setLoading(true);
    try {
      const token = sessionStorage.getItem("userToken");
      const res = await AxiosInstance.post(
        `${BaseUrl}/api/advt/delete`,
        { key: id },
        {
          headers: { "Content-Type": "application/json", Authorization: token },
        }
      );

      toast.dismiss(loadingToast);
      if (res.data.status === 200) {
        toast.success(res.data.message);
        // Re-fetch the current page. If the last item on a page was deleted,
        // we might need to go to the previous page.
        if (displayedNotifications.length === 1 && currentPage > 1) {
          fetchLinks(currentPage - 1);
        } else {
          fetchLinks(currentPage);
        }
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      toast.dismiss(loadingToast);
      toast.error("Error deleting notification.");
    } finally {
      setLoading(false);
    }
  };

  const handleTitleChange = (e) => {
    setNewNotification((prevState) => ({
      ...prevState,
      title: e.target.value,
    }));
  };

  const handleDateChange = (e) => {
    setNewNotification((prevState) => ({
      ...prevState,
      submissionDate: e.target.value,
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const validTypes = ["application/pdf"];
      if (!validTypes.includes(file.type)) {
        toast.error("Invalid file type. Please upload a PDF.");
        if (fileInputRef.current) fileInputRef.current.value = "";
        return;
      }
      setNewNotification((prevState) => ({ ...prevState, file }));
    }
  };

  const handleSave = async () => {
  if (
    newNotification.title &&
    newNotification.file &&
    newNotification.advertisementNo
  ) {
    const token = sessionStorage.getItem("userToken");

    if (newNotification.advertisementNo !== "Home Page") {
      if (!newNotification.submissionDate) {
        toast.error(
          "Published date is required for tenders and archived tenders."
        );
        return;
      }
    }

    const formData = new FormData();
    formData.append("multipart", newNotification.file);
    formData.append("title", newNotification.title);
    formData.append("advtNo", newNotification.advertisementNo);
    formData.append("publishedDate", newNotification.submissionDate);
    setLoading(true);

    try {
      const res = await AxiosInstance.post(
        `${BaseUrl}/api/advt/create`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: token,
          },
        }
      );

      if (res.data.status === 200) {
        toast.success(res.data.message);
        fetchLinks(1);
      } else {
        toast.error(res.data.message);
      }

      // Reset form
      setNewNotification({
        title: "",
        file: null,
        advertisementNo: "",
        submissionDate: "",
      });
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    } catch (error) {
      // 🔍 Detailed error handling
       handleAxiosError(error);

      // Reset
      setNewNotification({
        title: "",
        file: null,
        advertisementNo: "",
        submissionDate: "",
      });
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    } finally {
      setLoading(false);
    }
  } else {
    toast.error("Please fill in all required fields.");
  }
};


  const handleEditSave = async () => {
  

    if (!editAdvertisementNo) {
      toast.error("Advertisement/No cannot be empty.");
      return;
    }
    if (editAdvertisementNo !== "Home Page") {
      if (!currentNotification.submissionDate) {
        toast.error(
          "Published date is required for tenders and archived tenders."
        );
        return;
      }
    }

    const token = sessionStorage.getItem("userToken");
    const formData = new FormData();
    formData.append("title", editTitle);
    formData.append("key", currentEditId);
    formData.append("advtNo", editAdvertisementNo);
    formData.append("publishedDate", currentNotification.submissionDate);

    if (fileInputRef.current.files[0]) {
      const file = fileInputRef.current.files[0];
      const validTypes = ["application/pdf"];

      if (!validTypes.includes(file.type)) {
        toast.error("Invalid file type. Please upload a PDF.");
        fileInputRef.current.value = "";
        return;
      }
      formData.append("multipart", file);
    }
    setLoading(true);
    try {
      const res = await AxiosInstance.post(
        `${BaseUrl}/api/advt/update`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: token,
          },
        }
      );

      if (res.data.status === 200) {
        toast.success(res.data.message);
        fetchLinks(currentPage); // Re-fetch current page to reflect update
        setIsEditModalOpen(false);
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
   handleAxiosError(error);
    } finally {
      setLoading(false);
    }
  };

  const handleNewNotificationAdvertisementNoChange = (e) => {
    setNewNotification((prevState) => ({
      ...prevState,
      advertisementNo: e.target.value,
    }));
  };

  const handleSearch = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
    // Since search is client-side on `filteredNotifications`,
    // we don't need to call fetchLinks. Pagination will then be for the filtered set.
    setCurrentPage(1); // Reset to first page on new search
  };

  // Function to generate page numbers for pagination control
  const getPageNumbers = () => {
    const pageNumbers = [];
    const maxPagesToShow = 5; // e.g., 2 before, current, 2 after

    if (totalPages <= maxPagesToShow) {
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      // Always add the first page
      pageNumbers.push(1);

      // Determine the range of pages to show around the current page
      let startPage = Math.max(2, currentPage - Math.floor(maxPagesToShow / 2));
      let endPage = Math.min(totalPages - 1, currentPage + Math.floor(maxPagesToShow / 2));

      // Adjust start and end to ensure 'maxPagesToShow' numbers if possible
      if (currentPage <= Math.ceil(maxPagesToShow / 2)) {
        endPage = maxPagesToShow - 1;
        if (endPage >= totalPages) endPage = totalPages - 1; // Ensure it doesn't exceed totalPages
      } else if (currentPage + Math.floor(maxPagesToShow / 2) >= totalPages) {
        startPage = totalPages - maxPagesToShow + 2;
        if (startPage <= 0) startPage = 1; // Ensure it doesn't go below 1
      }

      // Add ellipsis if necessary before the central block
      if (startPage > 2) {
        pageNumbers.push('...');
      }

      // Add the central block of page numbers
      for (let i = startPage; i <= endPage; i++) {
        pageNumbers.push(i);
      }

      // Add ellipsis if necessary after the central block
      if (endPage < totalPages - 1) {
        pageNumbers.push('...');
      }

      // Always add the last page if it's not the first page
      if (totalPages > 1 && !pageNumbers.includes(totalPages)) {
        pageNumbers.push(totalPages);
      }
    }
    return pageNumbers;
  };



  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, totalItems);

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div className="home-dashboard">
          <div className="ticket-tab">
            <h3>Upload Advertisement</h3>
            <div className="row mb-3">
              <div className="col-md-6">
                <label className="form-label">
                  Advertisement/No{" "}
                  <span style={{ color: "red", fontSize: "1rem" }}>*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={newNotification.advertisementNo}
                  onChange={handleNewNotificationAdvertisementNoChange}
                  placeholder="Enter Advertisement/No"
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">
                  Title<span style={{ color: "red", fontSize: "1rem" }}>*</span>
                </label>
                <input
                  className="form-control"
                  name="title"
                  value={newNotification.title}
                  onChange={handleTitleChange}
                  placeholder="Enter Title to be displayed"
                />
              </div>

              <div className="col-md-6 mt-4">
                <label className="form-label">Published Date</label>
                <input
                  type="date"
                  className="form-control"
                  name="submissionDate"
                  value={newNotification.submissionDate}
                  onChange={handleDateChange}
                  placeholder="Enter Last Date of Submission"
                  onKeyDown={(e) => e.preventDefault()}
                />
              </div>
              <div className="col-md-6 mt-4">
                <label className="form-label">
                  Upload File<span style={{ color: "red", fontSize: "1rem" }}>*</span>
                </label>
                <input
                  type="file"
                  className="form-control"
                  name="file"
                  ref={fileInputRef}
                  onChange={handleFileChange}
                />
              </div>
              <div className="col-md-2 mt-2">
                <button
                  type="button"
                  className="btn btn-success mt-3"
                  onClick={handleSave}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
          <div className="ticket-tab">
            <div className="row mb-4">
              <div className="col-6">
                <h3>Manage Notifications</h3>
              </div>

              <div className="col-6">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search by title, Advertisement/No..."
                  value={searchQuery}
                  onChange={handleSearch}
                />
              </div>
            </div>
            <div className="table-responsive">
              <table className="table table-striped table-bordered table-hover">
                <thead>
                  <tr>
                    <th>Advertisement/No</th>
                    <th>Title</th>
                    <th>Published Date</th>
                    <th style={{ width: "15%" }}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {displayedNotifications.length > 0 ? (
                    displayedNotifications.map((notification) => (
                      <tr key={notification.id}>
                        <td>{notification.advertisementNo}</td>
                        <td>{notification.title}</td>
                        <td>{notification.submissionDate}</td>
                        <td>
                          <FaEye
                            className="me-2"
                            style={{ cursor: "pointer", color: "blue" }}
                            onClick={() => handleView(notification.id)}
                          />
                          <FaPencil
                            className="me-2"
                            style={{ cursor: "pointer", color: "orange" }}
                            onClick={() => handleEdit(notification.id)}
                          />
                          <FaTrash
                            style={{ cursor: "pointer", color: "red" }}
                            onClick={() => handleDelete(notification.id)}
                          />
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={4} className="text-center">
                        No Notifications Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <div className="row mt-4">
              <div className="col-5">
                {/* Improved total display */}
                {totalItems > 0 ? (
                  `Showing ${startIndex + 1}-${endIndex} of ${totalItems}`
                ) : (
                  "No items to display"
                )}
              </div>
              <div className="col-7 d-flex justify-content-end">
                <div className="d-flex align-items-center">
                  {/* Previous Button */}
                  <button
                    style={{ width: "8%", borderRadius: "50%" }}
                    className="btn btn-success"
                    onClick={handlePreviousPage}
                    disabled={currentPage === 1}
                  >
                    <FaAngleLeft />
                  </button>

                  {/* Page Numbers */}
                  <div className="mx-3 d-flex">
                    {getPageNumbers().map((pageNum, index) => (
                      pageNum === '...' ? (
                        <span key={`ellipsis-${index}`} className="mx-1">...</span>
                      ) : (
                        <button
                          key={pageNum}
                          className={`btn mx-1 ${currentPage === pageNum
                            ? "active btn-primary"
                            : "btn-light"
                            }`}
                          onClick={() => handlePageChange(pageNum)}
                        >
                          {pageNum}
                        </button>
                      )
                    ))}
                  </div>

                  {/* Next Button */}
                  <button
                    style={{ width: "8%", borderRadius: "50%" }}
                    className="btn btn-success"
                    onClick={handleNextPage}
                    disabled={currentPage >= totalPages}
                  >
                    <FaAngleRight />
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* View Modal */}
          <Modal
            isOpen={isViewModalOpen}
            toggle={() => setIsViewModalOpen(false)}
            centered
          >
            <ModalHeader toggle={() => setIsViewModalOpen(false)}>
              View Notification
            </ModalHeader>
            <ModalBody>
              {currentNotification && (
                <>
                  <h5>{currentNotification.title}</h5>
                  <iframe
                    src={currentNotification.file}
                    title="Notification File"
                    style={{ width: "100%", height: "350px" }}
                  ></iframe>
                </>
              )}
            </ModalBody>
          </Modal>

          {/* Edit Modal */}
          <Modal
            isOpen={isEditModalOpen}
            toggle={() => setIsEditModalOpen(false)}
            centered
          >
            <ModalHeader toggle={() => setIsEditModalOpen(false)}>
              Edit Notification
            </ModalHeader>
            <ModalBody>
              <div className="mb-3">
                <label className="form-label">
                  Advertisement/No
                  <span style={{ color: "red", fontSize: "1rem" }}>*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={editAdvertisementNo}
                  onChange={(e) => setEditAdvertisementNo(e.target.value)}
                  placeholder="Enter Advertisement/No"
                />
              </div>

              <div className="mb-3">
                <label htmlFor="editTitle" className="form-label">
                  Title<span style={{ color: "red", fontSize: "1rem" }}>*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="editTitle"
                  value={editTitle}
                  onChange={(e) => setEditTitle(e.target.value)}
                  placeholder="Enter notification title"
                />
              </div>
              <div className="mb-3">
                <label htmlFor="editTitle" className="form-label">
                  Published Date
                </label>
                <input
                  type="date"
                  className="form-control"
                  id="submissionDate"
                  value={currentNotification?.submissionDate || ""}
                  onChange={(e) =>
                    setCurrentNotification((prev) => ({
                      ...prev,
                      submissionDate: e.target.value,
                    }))
                  }
                  placeholder="Enter Last Date of Submission"
                  onKeyDown={(e) => e.preventDefault()}
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Upload New File (PDF only)</label>
                <input
                  type="file"
                  className="form-control"
                  ref={fileInputRef}
                />
              </div>
            </ModalBody>
            <ModalFooter className="flex-nowrap">
              <Button color="success" onClick={handleEditSave}>
                Save Changes
              </Button>
              <Button
                color="secondary"
                onClick={() => setIsEditModalOpen(false)}
              >
                Cancel
              </Button>
            </ModalFooter>
          </Modal>
        </div>
      )}
    </>
  );
};

export default Result;